import React, {useState, useEffect} from 'react';
import { useParams, useLocation} from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';

import { fetchStoryboardLeadReportSummary } from "actions/leads";

import { LeadSummary } from './components/leadSummary';
import { LeadAnalytics } from '../reports/components/leadAnalytics';
import { DatePickerView } from '../reports/components/datePicker';

import { generateReportUrl, parseQueryParams } from 'services/report.service';

import styles from './leadReports.module.scss';

const LeadsView =()=> {
  const dispatch = useDispatch();

  const [reportDate, setReportDate] = useState(null);
  const { search } = useLocation();
  let { storyboardId } = useParams();
  const summary = useSelector(state => _.get(state, 'lead.summary.items', {}));

  const handleDateChange = (value) => {
    setReportDate(value);
  }

  useEffect(() => {
    const parsedDate = parseQueryParams(search);
    setReportDate(parsedDate);

    dispatch(fetchStoryboardLeadReportSummary(storyboardId));
  }, []);

  return (
    <div className={styles.leadContainer} >
      <LeadSummary
        date={reportDate}
      />
      <div className={styles.statisticsView}>
          <LeadStatistics heading="Leads" subheading="Captured" stat={_.get(summary, "leads", 0) || 0} path={'/images/reports/leads.svg'}/>
          <LeadStatistics heading="Accounts" subheading="Influenced" stat={_.get(summary, "account", 0) || 0} path={'/images/leads/accounts.svg'}/>
          <LeadStatistics heading="Conversion" subheading="Rate" stat={`${_.get(summary, "conversion", 0) || 0}%`} path={'/images/leads/conversion.svg'}/>
      </div>
      <div className={styles.filters}>
        <DatePickerView
          value={reportDate}
          onChange={handleDateChange}
        />
      </div>  
      <LeadAnalytics
        showProfile={true}
        date={reportDate}
      />
    </div>
  )
}

const LeadStatistics =({heading,subheading,stat,path,iconClassname})=> {
  return (
    <div className={styles.wrapper}>
        <div>
            <h5 className={styles.heading}>{heading}</h5>
            <p className={styles.sub_heading}>{subheading}</p>
            <p className={styles.stat}>{stat}</p>
        </div>
        <div>
            <img src={path} className={iconClassname}/>
        </div>
        
    </div>
  )
}

export default LeadsView